/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-04 15:57:05
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-07-07 11:45:30
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\interaction\api\index.js
 */
import req from '@/utils/req.js'
//患者医生评论


//患者评价分页查询
export function getCommentPage(params) {
    return req.post('/admin/patient-comment/page',params)
}

//置顶/取消置顶/评论 （id）
export function setTop(params) {
    return req.put(`/admin/patient-comment/setTop?id=${params.id}`)
}


//审核通过,显示show，隐藏hidden  (id、visibility )
export function setAdopt(params) {
    return req.put(`/admin/patient-comment/setStatus?id=${params.id}&visibility=${params.visibility}`)
}

//设置单条数据岑显示隐藏(id)
export function setHidden(params) {
    return req.put(`/admin/patient-comment/setHidden?id=${params.id}`)
}

//获取未读条数
export function getUnreviewedCount(params) {
    return req.get('/admin/patient-comment/getUnreviewedCount',params)
}

//患者报道分页查询
export function patientOnboardPage(params) {
    return req.post('/admin/patient-onboard/page',params)
}

//数据分析 列表
export function statisticalMagnitude(params) {
    return req.post('/admin/patient-comment/statisticalMagnitude',params)
}

//到出数据分析excel
export function downloadStatistical(params) {
    return req.postUpload(`/admin/patient-comment/downloadStatistical`, params, { responseType:'arraybuffer' })
  }


//获取数据量
export function findAdminCommentOnboardCount(params) {
    return req.get('/admin/patient-comment/findAdminCommentOnboardCount',params)
}




